<template>
  <div class="kpi-container">
    <div class="kpi-header">
      <h5 class="kpi-title">
        Averages
        <icon v-if="devicesStatsLoading" name="spinner" spin class="loading-icon"></icon>
      </h5>
      <div class="date-picker-wrapper">
        <ulu-date-picker
          range
          v-model="range"
          lang="en"
          format="DD.MM.YYYY"
          :placeholder="$t('globals.all')"
        />
      </div>
    </div>

    <div class="table-wrapper" style="position: relative; min-height: 200px;">
      <div v-if="devicesStatsLoading" class="loading-overlay">
        <div class="spinner"></div>
        <p>{{ $t("globals.loading") }}...</p>
      </div>

      <table class="modern-table">
        <thead>
          <tr>
            <th v-for="field in fields" :key="field.key">
              {{ field.label || field.key }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!devicesStatsLoading && stats.length === 0">
            <td :colspan="fields.length" class="empty-state-cell">
              {{ $t("globals.no_results") }}
            </td>
          </tr>
          <tr v-for="(item, index) in stats" :key="index">
            <td>{{ item.kpi }}</td>
            <td>{{ item.quantity }}</td>
            <td>
              <span v-if="item.once != 0">
                {{ currencyFormat(item.once, item.currency) }}
              </span>
              <span v-else>-</span>
            </td>
            <td>
              <span v-if="item.monthly != 0">
                {{ currencyFormat(item.monthly, item.currency) }}
              </span>
              <span v-else>-</span>
            </td>
            <td>
              <span v-if="item.discount != 0">
                {{ currencyFormat(item.discount, item.currency) }}
              </span>
              <span v-else>-</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { mapActions, mapGetters } from "vuex";
import { currencyFormat } from "@/helpers/price";

import "vue-awesome/icons/spinner";

export default {
  components: {
    Icon: () => import("vue-awesome/components/Icon.vue"),
    "ulu-date-picker": DatePicker
  },
  data() {
    return {
      range: [null, null],
      formatedRange: [null, null],
      devicesStatsLoading: false,
      stats: [],
      fields: [
        {
          key: "kpi",
        },
        {
          key: "quantity",
          label: "Tot. quan."
        },
        {
          key: "once",
          label: "Avg. Once"
        },
        {
          key: "monthly",
          label: "Avg. Monthly"
        },
        {
          key: "discount",
          label: "Avg. Discount"
        }
      ]
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleFetch"]),
    currencyFormat,
    fetchData() {
      const data = {
        query: `
          query {
            KpiAvgTypes (
              ${ this.formatedRange[0]
                ? 'from: "' +this.formatedRange[0] + '", to: "' + this.formatedRange[1] + '"'
                : ''
              }
            )
          }
        `
      };

      this.devicesStatsLoading = true;
      this.simpleFetch({data, this_ref: this}).then((res) => {
        if (res) {
          this.stats = JSON.parse(res.KpiAvgTypes)
        }
      }).finally(()=>{
        this.devicesStatsLoading = false;
      });
    }
  },
  computed: {
    ...mapGetters(["getUserSystem"])
  },
  watch: {
    getUserSystem: function() {
      this.fetchData();
    },
    range: function(newRange) {
      if (newRange[0] !== null && newRange[1] !== null) {
        let from = new Date(newRange[0]);
        let to = new Date(newRange[1]);

        from.setHours(from.getHours() + 1);
        to.setHours(to.getHours() + 25);

        this.formatedRange = [
          `${from.getFullYear()}-${from.getMonth()+1}-${from.getDate()}`,
          `${to.getFullYear()}-${to.getMonth()+1}-${to.getDate()}`
        ];

        this.fetchData()
      } else {
        this.formatedRange = [null, null];
        this.fetchData()
      }
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>

<style scoped>
.kpi-container {
  padding: 0;
}

.kpi-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 16px;
  flex-wrap: wrap;
}

.kpi-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.loading-icon {
  color: #5469d4;
}

.date-picker-wrapper {
  flex-shrink: 0;
}

.date-picker-wrapper >>> .mx-datepicker {
  min-width: 280px;
}

.date-picker-wrapper >>> .mx-input {
  height: 40px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  padding: 8px 12px;
  font-size: 0.9375rem;
}

.table-wrapper {
  margin-top: 16px;
}

@media (max-width: 768px) {
  .kpi-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .date-picker-wrapper {
    width: 100%;
  }

  .date-picker-wrapper >>> .mx-datepicker {
    width: 100%;
  }
}
</style>
